/*
 * Vehicle steps, page name: puts the chosen make + model into the product h1, the browser tab
 * title, the breadcrumb, the mobile vehicle banner ([data-seatfit-vehicle-banner], filled from the
 * generation banner) and the prefill of every "Edit Vehicle" link. Liquid cannot read the query
 * string, so all of this is done here after the vehicle resolves; with no vehicle the originals return.
 */
(function () {
  'use strict';
  if (window.SeatFitStepsPage) return;
  var original = { h1: null, title: null };

  // Make + model are known for a covered vehicle and for a make/model link without a year.
  function known(ctx) {
    return !!(ctx && ctx.make && ctx.model && (ctx.status === 'ok' || ctx.reason === 'no-year'));
  }

  function name(tpl, ctx) {
    return window.SeatFitStepsModel.fill(tpl, { make: ctx.make.n, model: ctx.model.n, year: ctx.year || '' });
  }

  function heading(st) {
    var h1 = st.shop.info && st.shop.info.querySelector('.product__title > h1');
    if (!h1) return;
    if (original.h1 == null) original.h1 = h1.textContent.trim();
    var text = known(st.ctx) && st.s.title_template ? name(st.s.title_template, st.ctx) : original.h1;
    if (h1.textContent.trim() !== text) h1.textContent = text;
  }

  // Shopify titles read "<product title> – <shop>"; only the product part is swapped.
  function tabTitle(st) {
    if (original.title == null) original.title = document.title;
    if (!known(st.ctx) || !st.s.page_title_template) { document.title = original.title; return; }
    var text = name(st.s.page_title_template, st.ctx);
    var t = original.title;
    var p = original.h1 || '';
    document.title = p && t.indexOf(p) === 0 ? text + t.slice(p.length) : text + ' – ' + t;
  }

  function crumbItem(it, last, sep) {
    var li = document.createElement('li');
    li.className = 'product-breadcrumbs__item';
    li.setAttribute('data-sf-crumb', '');
    var node = document.createElement(last || !it.url ? 'span' : 'a');
    node.className = last ? 'product-breadcrumbs__current' : 'product-breadcrumbs__link';
    node.textContent = it.label;
    if (last) node.setAttribute('aria-current', 'page');
    else if (it.url) node.setAttribute('href', it.url);
    li.appendChild(node);
    if (!last) li.appendChild(separator(sep));
    return li;
  }

  function separator(sep) {
    var span = document.createElement('span');
    span.className = 'product-breadcrumbs__separator';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = sep;
    return span;
  }

  // Shrine's breadcrumb (auto mode, product in no collection) prints an empty list; we append
  // "Seat Covers / Leather / {Make} / {Model}" with Shrine's own classes, the model as current page.
  function crumbs(st) {
    var sec = document.getElementById('shopify-section-' + st.shop.sid);
    var list = (sec && sec.querySelector('.product-breadcrumbs__list')) || document.querySelector('.product-breadcrumbs__list');
    if (!list) return;
    Array.prototype.slice.call(list.querySelectorAll('[data-sf-crumb]')).forEach(function (n) { n.remove(); });
    var anySep = list.querySelector('.product-breadcrumbs__separator');
    var sep = anySep ? anySep.textContent.trim() || '/' : '/';
    var items = window.SeatFitStepsModel.parseLines(st.s.crumbs);
    var ctx = st.ctx;
    if (known(ctx)) {
      var base = (window.SeatFit.config().productUrl || '').split('?')[0];
      items.push({ label: ctx.make.n, url: base ? base + '?make=' + encodeURIComponent(ctx.make.s) : '' });
      items.push({ label: ctx.model.n, url: '' });
    }
    if (!items.length) return;
    var lastNative = list.lastElementChild;
    if (lastNative && !lastNative.querySelector('.product-breadcrumbs__separator')) {
      var s = separator(sep);
      s.setAttribute('data-sf-crumb', '');
      lastNative.appendChild(s);
    }
    items.forEach(function (it, i) { list.appendChild(crumbItem(it, i === items.length - 1, sep)); });
  }

  // Phone-only banner, matching the reference layout: car render + "Make / Model / years" of the generation in use.
  // The render is the competitor's CDN picture for review only, so it never sends a referrer.
  function banner(st) {
    var host = document.querySelector('[data-seatfit-vehicle-banner]');
    if (!host) return;
    var ctx = st.ctx;
    var row = st.sel && st.sel.row;
    var gens = (ctx && ctx.status === 'ok' && ctx.gens) || [];
    // Before a body/cab is picked the year may span several generations: show the first with art.
    var gen = row ? gens.filter(function (g) { return g.g === row.g; })[0]
      : gens.filter(function (g) { return g.banner; })[0];
    if (!gen || !gen.banner) { host.hidden = true; return; }
    [['[data-sf-make]', ctx.make.n], ['[data-sf-model]', ctx.model.n], ['[data-sf-gen]', gen.g]].forEach(function (p) {
      var el = host.querySelector(p[0]);
      if (el) el.textContent = p[1];
    });
    var img = host.querySelector('img');
    if (img) {
      img.setAttribute('referrerpolicy', 'no-referrer');
      img.alt = ctx.make.n + ' ' + ctx.model.n;
      if (img.getAttribute('src') !== gen.banner) img.setAttribute('src', gen.banner);
    }
    host.hidden = false;
  }

  // "Edit Vehicle" (href="#find-your-fit", placed by the template) opens the picker prefilled.
  function editLinks(st) {
    var d = window.SeatFitStepsModel.prefill(st.ctx, st.raw);
    var root = st.shop.info || document;
    root.querySelectorAll('.sf-edit-vehicle, [data-seatfit-edit-vehicle]').forEach(function (a) {
      Object.keys(d).forEach(function (k) {
        if (d[k]) a.setAttribute('data-' + k, d[k]);
        else a.removeAttribute('data-' + k);
      });
    });
  }

  function apply(st) {
    [heading, tabTitle, crumbs, banner, editLinks].forEach(function (fn) {
      try { fn(st); } catch (e) { console.warn('[SeatFit] page name update failed', e); }
    });
  }

  window.SeatFitStepsPage = { apply: apply, known: known };
})();
